import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import "./Footer.scss"
import logo from "../images/ionq-logo-one-color.svg"

const Footer = () => {
  let termsPages = useStaticQuery(graphql`
    query FooterQuery {
      allContentfulTermsPage(filter:{showInFooter:{ eq:true}}, sort:{footerPosition:ASC}) {
        nodes {
          slug
          pageTitle
        }
      }
    }
  `)?.allContentfulTermsPage?.nodes
  return (
    <div className="Footer">
      <nav aria-label="footer navigation" className="footer-content">
        <div className="footer-nav-grid">
          <div className="footer-nav-group">
            <img className="footer-logo" src={logo} alt="IonQ logo" />
            <AnchorLink className="footer-nav-link" to="/company">
              About IonQ
            </AnchorLink>
            <AnchorLink className="footer-nav-link" to="/company#leadership">
              Leadership
            </AnchorLink>
            <AnchorLink className="footer-nav-link" to="/company#board">
              Board & Advisors
            </AnchorLink>
            <AnchorLink className="footer-nav-link" to="/careers">
              Jobs
            </AnchorLink>
          </div>
          <div className="footer-nav-group">
            <p className="footer-nav-link -header">Resources</p>
            <Link className="footer-nav-link" to="/technology">
              Our Technology
            </Link>

            <Link className="footer-nav-link" to="/resources/learn">
              Blog
            </Link>
            <Link className="footer-nav-link" to="/resources/publications">
              Publications
            </Link>
            <Link className="footer-nav-link" to="/news">
              Newsroom
            </Link>
            <Link className="footer-nav-link" to="/news">
              Press & Media
            </Link>
            <Link className="footer-nav-link" to="http://shop.ionq.com">
              Shop
            </Link>
            <Link className="footer-nav-link" to="/subscribe">
              Subscribe
            </Link>
          </div>
          <div className="footer-nav-group">
            <p className="footer-nav-link -header">Quantum Cloud</p>
            <Link className="footer-nav-link" to="/get-started">
              Get Started
            </Link>
            <Link className="footer-nav-link" to="/docs">
              Docs & Guides
            </Link>
            <AnchorLink
              className="footer-nav-link"
              to="/get-started#partnerships"
            >
              Partnerships
            </AnchorLink>
            <Link className="footer-nav-link" to="/programs/research-credits">
              Research Credits
            </Link>
            <Link className="footer-nav-link" to="/early-access">
              Early Access
            </Link>
          </div>
          <div className="footer-nav-group">
            <Link className="footer-nav-link" to="/contact">
              Contact
            </Link>
            {
              termsPages.map(page => (
                <Link className="footer-nav-link" to={`/${page.slug}`}>
                  {page.pageTitle}
                </Link>
              ))
            }
            <p className="footer-copyright-text">
              <br />
              Copyright © 2017-{new Date().getFullYear()} IonQ, Inc.
            </p>
            <p className="footer-copyright-text">All Rights Reserved.</p>
            <div className="footer-social-links">
              <a
                aria-label="subscribe to our email list"
                target="_blank"
                rel="noopener noreferrer"
                href="/subscribe"
              >
                <svg
                  className="email-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M0.8,5.1C0.5,5.6,0.3,6.2,0.3,6.8v10.5c0,0.6,0.2,1.2,0.5,1.7L7.6,12L0.8,5.1z" />
                  <path d="M23.1,19c0.4-0.5,0.6-1.1,0.6-1.8V6.8c0-0.6-0.2-1.3-0.6-1.8l-6.9,7L23.1,19z" />
                  <path
                    d="M15.1,13.1c-0.9,0.9-2,1.4-3.2,1.4s-2.3-0.5-3.2-1.4L8.5,13l-6.8,6.9c0.4,0.3,1,0.4,1.5,0.4h17.5c0.5,0,0.9-0.1,1.3-0.3
                  L15.3,13L15.1,13.1z"
                  />
                  <path
                    d="M20.8,3.8H3.2c-0.5,0-1,0.1-1.5,0.4L8.5,11l0.9,1l0.2,0.2c0.7,0.7,1.5,1,2.3,1c0.8,0,1.6-0.4,2.3-1l0.2-0.2l0.9-1l6.8-6.9
                  C21.7,3.9,21.2,3.8,20.8,3.8z"
                  />
                </svg>
              </a>
              <a
                aria-label="visit IonQ on Twitter"
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/ionq_inc"
              >
                <svg
                  className="twitter-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 20 18"
                >
                  <path xmlns="http://www.w3.org/2000/svg" d="M0.373878 0.731445L7.32347 10.0235L0.330078 17.5785H1.90413L8.02697 10.9639L12.9739 17.5785H18.3301L10.9893 7.7638L17.4988 0.731445H15.9247L10.2861 6.82317L5.73008 0.731445H0.373878ZM2.6886 1.89077H5.14921L16.0151 16.4191H13.5544L2.6886 1.89077Z" fill="#666666"/>
                </svg>
              </a>
              <a
                aria-label="visit IonQ on Linkedin"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/ionq.co/"
              >
                <svg
                  className="linkedin-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Footer